import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Button,
  Checkbox,
  TextField,
  Tooltip,
  IconButton,
  Icon,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MiniPatientProfile from './miniPatientProfile';
import {
  makeS3BlobsRenderable,
  fileSelectHandler,
} from '../../../util/fileHandling';
import {
  fetchPatientById,
  markNotificationAsRead,
  markNotificationArchived,
  markNotificationUnarchived,
  requestUpdateNotificationPortalNote,
  fetchAppointmentAttachments,
  fetchConsultNoteAttachments,
} from '../../../services/api';
import moment from 'moment';
import './style.css';
import AttachmentIcon from '@material-ui/icons/Attachment';
import ArchiveIcon from '@material-ui/icons/Archive';
import { CircularProgress } from '@material-ui/core';
import UnarchiveIcon from '@material-ui/icons/Unarchive';

const styles = {
  unreadBadge: {
    height: '12px',
    width: '12px',
    borderRadius: 50,
    marginRight: '5px',
    backgroundColor: '#36d686',
  },
  requestSummaryBar: {
    backgroundColor: 'rgba(255, 228, 145, .5)',
  },
  bookSummaryBar: {
    backgroundColor: 'rgba(141, 214, 143, .5)',
  },
  cancelSummaryBar: {
    backgroundColor: 'rgba(214, 150, 141, .5)',
  },
  messageSummaryBar: {
    backgroundColor: 'rgba(163, 217, 217, .5)',
  },
  customTopSpacing: {
    marginTop: '35px',
  },
};

function NotificationRow(props) {
  const {
    updateNotification,
    notification,
    enqueueSnackbar,
    filterBoxEnable,
    currentUser,
    classes: {
      unreadBadge,
      requestSummaryBar,
      bookSummaryBar,
      cancelSummaryBar,
      messageSummaryBar,
      customTopSpacing,
    },
  } = props;

  let color;
  if (notification.type === 'request') color = requestSummaryBar;
  if (notification.type === 'booking') color = bookSummaryBar;
  if (notification.type === 'cancellation') color = cancelSummaryBar;
  if (notification.type === 'message') color = messageSummaryBar;

  const [expanded, setExpanded] = useState(false);
  const [images, setImages] = useState([]);
  const [patient, setPatient] = useState({});
  const [unsavedPortalNotes, setUnsavedPortalNotes] = useState(
    notification[notification.joinType].portalNotes || ''
  );
  const [notificationId, setNotificationId] = useState('');

  const fetchPatient = async patientId => {
    const res = await fetchPatientById(patientId);
    setPatient(res);
  };

  useEffect(() => {
    if (filterBoxEnable) {
      setExpanded(false);
    }
    props.expandedCloseReturn();
  }, [filterBoxEnable]);
  const handleExpand = async e => {
    e.stopPropagation();
    if (!expanded) {
      try {
        const fullNotification = await markNotificationAsRead(notification.id);
        let patientId;
        let attachmentId;
        let messageId;
        let apiResponse;

        if (fullNotification.appointment)
          patientId = fullNotification.appointment.patient.id;
        if (fullNotification.appointmentRequest)
          patientId = fullNotification.appointmentRequest.patient.id;
        if (fullNotification.message)
          patientId = fullNotification.message.patient.id;
        fetchPatient(patientId);
        if (fullNotification.appointment)
          attachmentId = fullNotification.appointment.id;
        if (fullNotification.appointmentRequest)
          messageId = fullNotification.appointmentRequest.id;
        if (fullNotification.message) messageId = fullNotification.message.id;
        // setAppointmentId(notification.appointment.id);
        if (attachmentId) {
          apiResponse = await fetchAppointmentAttachments(attachmentId);
        }
        if (messageId) {
          apiResponse = await fetchConsultNoteAttachments(messageId);
        }

        const imageObjects = makeS3BlobsRenderable(apiResponse.data);

        setImages(imageObjects);
        updateNotification({
          ...notification,
          ...fullNotification,
          open: true,
        });
      } catch (err) {
        // enqueueSnackbar('Notification failed to be retrieved.');
        console.log(err);
      }
    } else {
      updateNotification({ open: false });
    }

    setExpanded(!expanded);

    if (!notification.readAt) {
      try {
        await markNotificationAsRead(notification.id);
        updateNotification({ readAt: true }); // bad but will do for now
      } catch (err) {
        // do something sad
        console.log(err);
      }
    }
  };

  const savePortalNotes = async () => {
    try {
      await requestUpdateNotificationPortalNote({
        notificationId: notification.id,
        noteBody: unsavedPortalNotes,
      });
      updateNotification({ portalNotes: unsavedPortalNotes }); // bad but will do for now
      enqueueSnackbar('Note officially updated!');
    } catch (err) {
      enqueueSnackbar('Oops something went wrong, please try again.');
      console.log(err);
    }
  };

  // const toggleArchived = async e => {
  //   e.stopPropagation();
  //   const archived = notification[notification.joinType].archivedById;
  //   try {
  //     if (!archived) {
  //       await markNotificationArchived(notification.id);
  //     } else {
  //       await markNotificationUnarchived(notification.id);
  //     }
  //     updateNotification({
  //       ...notification,
  //       [notification.joinType]: {
  //         ...notification[notification.joinType],
  //         archivedById: archived ? null : currentUser.id,
  //       },
  //     });
  //   } catch (err) {
  //     enqueueSnackbar('Sorry. Something went wrong.');
  //     console.log(err);
  //   }
  // };

  const toggleArchievedChange = async () => {
    // e.stopPropagation();
    props.setArchieveLoader(true);
    // props.archieve(true);
    const archived = notification.archivedAt;
    setNotificationId(notification.id);
    try {
      if (!archived) {
        await markNotificationArchived(notification.id);
      } else {
        await markNotificationUnarchived(notification.id);
      }
      const now = new Date().toISOString();
      // updateNotification({
      //   ...notification,
      //   [notification.joinType]: {
      //     ...notification[notification.joinType],
      //     archivedById: archived ? null : currentUser.id,
      //   },
      // });
      // console.log(archived,"archived");
      // console.log((archived) ? null : now,"archiAT")
      updateNotification({
        ...notification,
        archivedAt: (archived) ? null : now
      });
      setNotificationId('');
    } catch (err) {
      enqueueSnackbar('Sorry. Something went wrong.');
      console.log(err);
    }
  };

  const summary = () => {
    switch (notification.type) {
      case 'request':
        const createdByPatient =
          !notification.createdByFirstName ||
          notification.patientFirstName + notification.patientLastName ===
            notification.createdByFirstName + notification.createdByLastName;
        return createdByPatient
          ? `${notification.patientFirstName} ${
              notification.patientLastName
            } requested an appt with ${notification.providerFirstName} ${
              notification.providerLastName
            }`
          : `${notification.createdByFirstName} ${
              notification.createdByLastName
            } sent ${notification.patientFirstName} ${
              notification.patientLastName
            } to ${notification.providerFirstName} ${
              notification.providerLastName
            }`;
      case 'booking':
        return `${
          notification.createdByFirstName
            ? `${notification.createdByFirstName} ${
                notification.createdByLastName
              } `
            : ''
        }booked ${notification.patientFirstName} ${
          notification.patientLastName
        } to see ${notification.providerFirstName} ${
          notification.providerLastName
        } on ${moment(notification.appointment.time).format(
          'ddd, MMM Do - h:mm a'
        )} ${moment(notification.appointment.time).format('YYYY')}`;
      case 'cancellation':
        return `${
          notification.createdByFirstName
            ? `${notification.createdByFirstName} ${
                notification.createdByLastName
              } `
            : ''
        }cancelled ${notification.patientFirstName} ${
          notification.patientLastName
        } with ${notification.providerFirstName} ${
          notification.providerLastName
        } on ${moment(notification.appointment.time).format(
          'ddd, MMM Do - h:mm a'
        )} ${moment(notification.appointment.time).format('YYYY')}`;
      case 'message':
        return `Message from ${notification.createdByFirstName} ${
          notification.createdByLastName
        }${
          notification.patientFirstName
            ? ` about ${notification.patientFirstName} ${
                notification.patientLastName
              }`
            : ''
        }`;
      default:
        return `new notification`;
    }
  };

  const NotificationSummary = () => (
    <Grid direction="row" container justifyContent="space-between">
      <Grid item container sm={6} alignItems="center">
        {!notification.readAt && <div className={unreadBadge} />}
        <Typography>{summary()}</Typography>
      </Grid>
      <Grid item container sm={6} alignItems="center">
        <Grid
          item
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sm={5}
        >
          <Grid item container justifyContent="flex-end" alignItems="center">
            {/* <Checkbox
              checked={!!notification[notification.joinType].archivedById}
              onChange={(e) => toggleArchived(e)}
            /> */}
            {/* <span>
              {notification[notification.joinType].archivedById
                ? 'Mark Unarchived'
                : 'Mark Archived'}
            </span> */}
            {/* <span className="attachment-icon">
              {notification[notification.joinType].isAttachment ? (
                <Icon>
                  <AttachmentIcon />
                </Icon>
              ) : (
                ''
              )}
            </span> */}
            <span className="archieve-button">
              {props.archieveLoader ? (
                <Grid
                  container
                  justifyContent="center"
                  alignContent="center"
                  style={{ height: '200%' }}
                >
                  {notification.id == notificationId ? (
                    <CircularProgress />
                  ) : (
                    <IconButton onClick={e => toggleArchievedChange(e)}>
                      {notification.archivedAt ? (
                        <Tooltip title="UnArchive" arrow>
                          <UnarchiveIcon />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Archive" arrow>
                          <ArchiveIcon />
                        </Tooltip>
                      )}
                    </IconButton>
                  )}
                </Grid>
              ) : (
                <IconButton onClick={e => toggleArchievedChange(e)}>
                  {notification.archivedAt ? (
                    <Tooltip title="UnArchive" arrow>
                      <UnarchiveIcon />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Archive" arrow>
                      <ArchiveIcon />
                    </Tooltip>
                  )}
                </IconButton>
              )}
              {/* {notification[notification.joinType].archivedById
                ? 'Mark Unarchived'
                : 'Mark Archived'} */}
            </span>
          </Grid>
          {/* <Grid item container justify="center" alignItems="center">
            {notification.archivedBy && (
              <span>
                Archived By:
                {notification[notification.joinType].archivedById ===
                  currentUser.id
                  ? ' You'
                  : ` ${notification.archivedBy.firstName} ${
                  notification.archivedBy.lastName
                  }`}
              </span>
            )}
          </Grid> */}
        </Grid>
        <Grid item container alignItems="center" sm={7}>
          <div className="custom-para-align">
            <Typography>
              Sent on:{' '}
              {moment(notification.createdAt).format('ddd, MMM Do - h:mm a')}
            </Typography>
            {notification &&
            notification.type === 'booking' &&
            notification.appointment.createdAt ? (
              <Typography>
                Created on:{' '}
                {moment(notification.appointment.createdAt).format(
                  'ddd, MMM Do - h:mm a'
                )}
              </Typography>
            ) : null}{' '}
            {notification &&
            notification.type === 'cancellation' &&
            notification.appointment.cancelledDate ? (
              <div>
                <Typography>
                  Cancelled on:{' '}
                  {moment(notification.appointment.cancelledDate).format(
                    'ddd, MMM Do - h:mm a'
                  )}
                </Typography>
                <Typography>
                  Created on:{' '}
                  {moment(notification.appointment.createdAt).format(
                    'ddd, MMM Do - h:mm a'
                  )}
                </Typography>
              </div>
            ) : null}
          </div>
        </Grid>
      </Grid>
    </Grid>
  );

  const NotificationStatusForm = () => (
    <Grid container direction="column">
      <Grid container direction="row" justifyContent="space-around">
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          sm={5}
          style={{ marginTop: '10px' }}
        >
          <TextField
            fullWidth
            multiline
            rows="5"
            variant="outlined"
            label="Notes"
            name="Notes"
            defaultValue={unsavedPortalNotes}
            onChange={event => setUnsavedPortalNotes(event.target.value)}
          />
        </Grid>
        <Grid
          item
          container
          direction="column"
          sm={5}
          style={{ marginTop: '10px' }}
        >
          {['booking', 'request'].includes(notification.type) ? (
            <TextField
              fullWidth
              multiline
              disabled
              rows="5"
              variant="outlined"
              label={`Reason for ${notification.type}`}
              defaultValue={notification[notification.joinType].patientReason}
            />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item container justifyContent="center" alignItems="center" sm={3}>
          <Button
            className="custom-save-notes-btn"
            color="primary"
            variant="contained"
            onClick={savePortalNotes}
          >
            Save Notes
          </Button>
        </Grid>
        {/* <Grid
          item
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sm={3}
        >
          <Grid item container justifyContent="center" alignItems="center">
            <Checkbox
              checked={!!notification[notification.joinType].archivedById}
              onChange={toggleArchived}
            />
            <Typography>
              {notification[notification.joinType].archivedById
                ? 'Unarchive'
                : 'Archive'}
            </Typography>
          </Grid> */}
          {/* <Grid item container justifyContent="center" alignItems="center">
            {notification &&
              notification.archivedBy &&
              notification.archivedBy.firstName && (
                <Typography variant="caption">
                  Archived By:
                  {notification[notification.joinType].archivedById ===
                  currentUser.id
                    ? ' You'
                    : ` ${notification.archivedBy.firstName} ${
                        notification.archivedBy.lastName
                      }`}
                </Typography>
              )}
          </Grid> */}
        {/* </Grid> */}
      </Grid>
    </Grid>
  );

  return (
    <>
      {/* <div className={customTopSpacing}> */}
      <Accordion expanded={expanded}>
        <AccordionSummary
          className={color}
          expandIcon={<ExpandMoreIcon onClick={e => handleExpand(e)} />}
        >
          <NotificationSummary />
        </AccordionSummary>
        <AccordionDetails>
          {expanded && (
            <Grid container direction="column">
              {NotificationStatusForm()}

              <MiniPatientProfile
                patient={patient}
                images={images}
                setPatient={setPatient}
              />
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      {/* </div> */}
    </>
  );
}

export default withSnackbar(withStyles(styles)(NotificationRow));
